import { AnalyticsEvents, trackEvent } from "@axqora/analytics";
import type { LandingContent, Locale, PageKind } from "../content/types";
import { luxoriaConfig } from "../config";
import { localeHref } from "../i18n/routes";
import { Container } from "./Container";
import { BrandMark } from "./BrandMark";

type FooterProps = {
  locale: Locale;
  kind: PageKind;
  content: LandingContent["footer"];
};

export function Footer({ locale, kind, content }: FooterProps) {
  const linkClass = "text-sm text-text-secondary transition-colors hover:text-text-primary";

  return (
    <footer className="border-t border-subtle bg-bg-primary py-16">
      <Container>
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <BrandMark size={28} />
              <span className="font-display text-lg font-bold text-text-primary">Luxoria</span>
            </div>
            <p className="mt-3.5 text-sm leading-relaxed text-text-secondary">{content.tagline}</p>
          </div>

          <nav className="flex flex-wrap gap-x-8 gap-y-3.5" aria-label={content.legalHeading}>
            <a
              href={localeHref(locale, "privacy")}
              className={linkClass}
              onClick={() =>
                trackEvent(AnalyticsEvents.PrivacyClick, {
                  product: "luxoria",
                  page: kind,
                  locale,
                  target: "footer_privacy"
                })
              }
            >
              {content.privacy}
            </a>
            <a href={localeHref(locale, "terms")} className={linkClass}>
              {content.terms}
            </a>
            <a href={localeHref(locale, "support")} className={linkClass}>
              {content.supportLabel}
            </a>
            <a
              href={`mailto:${luxoriaConfig.contactEmail}`}
              className={linkClass}
              onClick={() =>
                trackEvent(AnalyticsEvents.ContactClick, {
                  product: "luxoria",
                  page: kind,
                  locale,
                  target: "footer_email"
                })
              }
            >
              {content.contactHeading}
            </a>
          </nav>
        </div>

        <div className="mt-10 border-t border-subtle pt-6 text-center">
          <p className="text-[13px] text-text-muted">
            {"© "}
            <a className="hover:underline" href="https://axqora.com" rel="noopener noreferrer" target="_blank">
              2026 Axqora
            </a>
            {" · "}
            <a className="hover:underline" href={content.icpHref} rel="noopener noreferrer" target="_blank">
              {content.icp}
            </a>
          </p>
        </div>
      </Container>
    </footer>
  );
}
